// extracted by mini-css-extract-plugin
export default {"equipmentList":"DeviceList_equipmentList__XUuLr","noQty":"DeviceList_noQty__wFLTp","dotSpan":"DeviceList_dotSpan__IisI9"};